// extracted by mini-css-extract-plugin
module.exports = {"trustInfo":"ProductDashboardGuarantee_trustInfo__l_4L_"};